<rt-dropdown
  [style.width.px]="width"
  [style.min-width]="minWidthAttr"
  [style.max-width.px]="maxWidth"
  [style.max-height]="noMaxHeight ? 'none' : null"
  [class.no-bottom-border-radius]="hasStickyFooter"
  [class.margin-bottom]="!hasStickyFooter"
  #rtDropdown
>
  <ng-template [ngTemplateOutlet]="template"> </ng-template>
</rt-dropdown>
@if (hasStickyFooter) {
  <div class="sticky-footer">
    <ng-template
      [ngTemplateOutlet]="footerTemplate || null"
      [ngTemplateOutletContext]="footerTemplateContext || null"
    >
    </ng-template>
  </div>
}
